import React from 'react'
import TabGroup from './TabGroup'
import { COMMON_ATTRIBUTES, UNIQUE_ATTRIBUTES_SOURCE, UNIQUE_ATTRIBUTES_TARGET } from '../utils/Constants';
import TabContent from './TabContent';

type SelectAttributesProps = {
  payload: TRecategorizePayload;
  setPayload: React.Dispatch<React.SetStateAction<TRecategorizePayload>>;
  recategorizationResponse: RecategorizationResponse | undefined;
  setAttributeValueData: React.Dispatch<React.SetStateAction<AttributeValueMapping | null>>;
  activeTabIndex: number;
  setActiveTabIndex: React.Dispatch<React.SetStateAction<number>>;
}

const SelectAttributes = ({ payload, setPayload, recategorizationResponse, setAttributeValueData, activeTabIndex, setActiveTabIndex }
  : SelectAttributesProps) => {

  const tabs = [
    { label: COMMON_ATTRIBUTES },
    { label: UNIQUE_ATTRIBUTES_SOURCE },
    { label: UNIQUE_ATTRIBUTES_TARGET },
  ];

  const handleTabClick = (index: number) => {
    setActiveTabIndex(index);
  };

  return (<div className='tw-columns-1'>
    <TabGroup tabs={tabs}
      activeTabIndex={activeTabIndex}
      onTabClick={handleTabClick}
    />
    <TabContent activeTabIndex={activeTabIndex}
      payload={payload}
      setPayload={setPayload}
      recategorizationResponse={recategorizationResponse}
      setAttributeValueData={setAttributeValueData}
    />
  </div>
  )
}

export default SelectAttributes